// // const url = "https://api.ares.ldttechnology.com"
// // const url = "http://13.233.191.31:";
// const url = "http://122.176.50.200:";
// export const environment = {
//   production: true,
//   // BASE_ENDPOINT: "http://mfs.ldttechnology.com/paypro/",
//   // DFS_ENDPOINT: "http://mfs.ldttechnology.com/dfs-core/",
//   // API_ENDPOINT: "http://mfs.ldttechnology.com/payprofront/",
//   // HSM_API_ENDPOINT: "http://mfs.ldttechnology.com/hsmapi/",
//   // MFS_API_ENDPOINT: "http://mfs.ldttechnology.com/mfs/",
//   // MFS_USER_GROUP_API_ENDPOINT: 'http://mfs.ldttechnology.com/paypro/usergroup/',
//   // WALLET_MANAGEMENT_ENDPOINT: "http://mfs.ldttechnology.com/paypro/wallet/",
//   // DFS_USER_GROUP_API_ENDPOINT : 'http://mfs.ldttechnology.com/paypro/',
//   // DFS_LOYALTY_ENDPOINT: 'http://mfs.ldttechnology.com/mfs-loyalty-management/',
//   // //ENDPOINT: 'http://mfs.ldttechnology.com/paypro/transaction/',
//   // ENDPOINT: 'http://mfs.ldttechnology.com/paypro/',
//   // USER_MFS: 'http://mfs.ldttechnology.com/paypro/user/',
//   // LIMIT_MANAGEMENT_ENDPOINT: "http://mfs.ldttechnology.com/paypro/ruleset/",
//   // COMMON_UTILS: "http://mfs.ldttechnology.com/paypro/common/",
//   // LOGIN_MFS: 'http://mfs.ldttechnology.com/paypro/login/',
//   // MFS_SERVICE_MANAGEMENT_API_ENDPOINT: 'http://mfs.ldttechnology.com/paypro/service/',
//   // SOCKET_URL: "http://mfs.ldttechnology.com/paypro",
//   // MFS_SERVICE_GROUP_MANAGEMENT_ENDPOINT: "http://mfs.ldttechnology.com/paypro/serviceGroup/",
//   // COMMON_UTILS_HIERARCHY: "http://mfs.ldttechnology.com/paypro/commonutils/",
//   // MFS_HIERARCHY_DOWNLOAD: "http://mfs.ldttechnology.com/mfs-common-utilities/commonutils/",
//   // MFS_REPORTS_ENDPOINT: "http://mfs.ldttechnology.com/mfs-reporting-service/",
//   // OPERATIONS_ENDPOINT: "http://mfs.ldttechnology.com/mfs-wallet-management/Master/",
//   // BILLER_ENDPOINT: "http://mfs.ldttechnology.com/paypro/biller/",
//   // DASHBOARD_ENDPOINT: "http://mfs.ldttechnology.com/mfs-reporting-service/",
//   // MFS_TRANSACTION_MANAGEMENT_API_ENDPOINT: "http://mfs.ldttechnology.com/mfs-transaction-management/balanceManagement/",
//   // IMAGE_STORAGE_ENDPOINT: "http://mfs.ldttechnology.com/UploadedData/",
//   // SMS_ENDPOINT: "http://mfs.ldttechnology.com/mfs-sms-management/",
//   // CRM_ENDPOINT: "http://crmdfsdev.spicelabs.in/",
//   // POINTPRO_ENDPOINT: "http://mfs.ldttechnology.com/paypro/pointPro/",
//   // CAMPAIGN_ENDPOINT: "http://mfs.ldttechnology.com/mfs-campaign-management/",
//   // PRODIGI_CREDIT_ENDPOINT: "http://creditengine.spicelabs.in/",

//   // URL: "http://api.ares.ldttechnology.com",
//   // BHA : "https://api.ares.ldttechnology.com",
//   BASE_ENDPOINT: url + "7071/mfs-user-group-management/",
//   DFS_ENDPOINT: url + "8800/dfs-core/",
//   API_ENDPOINT: url + "/payprofront/",
//   HSM_API_ENDPOINT: url + "/hsmapi/",
//   MFS_API_ENDPOINT: url + "/mfs/",
//   MFS_USER_GROUP_API_ENDPOINT:
//     url + "7071/mfs-user-group-management/usergroup/",
//   WALLET_MANAGEMENT_ENDPOINT:
//     url + "9086/mfs-wallet-management/walletManagement/",
//   DFS_USER_GROUP_API_ENDPOINT: url + "7071/mfs-user-group-management/",
//   DFS_LOYALTY_ENDPOINT: url + "9077/mfs-loyalty-management/",
//   //ENDPOINT: 'http://mfs.ldttechnology.com/paypro/transaction/',
//   ENDPOINT: url + "9085/mfs-user-management/",
//   USER_MFS: url + "9085/mfs-user-management/",
//   LIMIT_MANAGEMENT_ENDPOINT: url + "9091/mfs-ruleset-service-management/",
//   COMMON_UTILS: url + "7071/mfs-user-group-management/common/",
//   LOGIN_MFS: url + "9085/mfs-user-management/adminController/",
//   MFS_SERVICE_MANAGEMENT_API_ENDPOINT: url + "9088/mfs-service-management/",
//   SOCKET_URL: url + "/paypro",
//   MFS_SERVICE_GROUP_MANAGEMENT_ENDPOINT:
//     url + "9089/mfs-service-group-management/serviceGroup/",
//   COMMON_UTILS_HIERARCHY: url + "/paypro/commonutils/",
//   MFS_HIERARCHY_DOWNLOAD: url + "mfs-common-utilities/commonutils/",
//   MFS_REPORTS_ENDPOINT: url + "/mfs-reporting-service/",
//   OPERATIONS_ENDPOINT: url + "9086/mfs-wallet-management/Master/",
//   BILLER_ENDPOINT: url + "9099/mfs-biller-gateway/biller/",
//   DASHBOARD_ENDPOINT: url + "/mfs-reporting-service/",
//   MFS_TRANSACTION_MANAGEMENT_API_ENDPOINT:
//     url + "/mfs-transaction-management/balanceManagement/",
//   IMAGE_STORAGE_ENDPOINT: url + "/UploadedData/",
//   SMS_ENDPOINT: url + "/mfs-sms-management/",
//   CRM_ENDPOINT: url + "8090",
//   POINTPRO_ENDPOINT: url + "9086/mfs-wallet-management/poinPro/",
//   CAMPAIGN_ENDPOINT: url + "9073/mfs-campaign-management/",
//   PRODIGI_CREDIT_ENDPOINT: "http://api.ares.ldttechnology.com/",
//   DFS_USER_MANAGEMENT_ENDPOINT: url + "8086/dfs-user-management/v1/",
//   DFS_WALLET_MANAGEMENT_ENDPOINT: url + "8087/dfs-wallet-management/v1/",
//   SHOW_MODULE: {
//     dashboard: false,
//     walletManagement: true,
//     serviceManagement: true,
//     serviceGroupManagement: true,
//     ruleManagement: true,
//     userGroupManagement: true,
//     hierarchyManagement: true,
//     limitsAndCapping: true,
//     promocodeManagement: true,
//     loginManagement: true,
//     operations: true,
//     billerManagement: true,
//     brmsTestPad: true,
//     cashinManagement: true,
//     notificationManagement: true,
//     reports: false,
//     kycRequests: true,
//     mpc: false,
//     fundTransfer: true,
//     loyaltyManagement: true,
//   },
//   OPEN_MODULE: ["main/dashboard"],
// };

//AWS ENDPOINT
const url =
  // "http://ad7eadde08d0d4ed2b61893a8ff055ce-c7f31e1a98c7d2eb.elb.af-south-1.amazonaws.com/";
  // "http://16.28.49.116:31509/";
  // "http://13.246.23.236:31509/";
  // "http://13.246.209.72:31509/";
  // "https://backend.swapgm.com/";
"https://api.ares.ldttechnology.com/";
export const environment = {
  production: true,

  BASE_ENDPOINT: url + "mfs-user-group-management/",
  DFS_ENDPOINT: url + "dfs-core/",
  API_ENDPOINT: url + "/payprofront/",
  HSM_API_ENDPOINT: url + "/hsmapi/",
  MFS_API_ENDPOINT: url + "/mfs/",
  MFS_USER_GROUP_API_ENDPOINT: url + "mfs-user-group-management/usergroup/",
  WALLET_MANAGEMENT_ENDPOINT: url + "mfs-wallet-management/walletManagement/",
  MFS_WALLET_MANAGEMENT_ENDPOINT: url + "mfs-wallet-management/",
  DFS_USER_GROUP_API_ENDPOINT: url + "mfs-user-group-management/",
  DFS_LOYALTY_ENDPOINT: url + "mfs-loyalty-management/",
  ENDPOINT: url + "mfs-user-management/",
  USER_MFS: url + "mfs-user-management/",
  LIMIT_MANAGEMENT_ENDPOINT: url + "mfs-ruleset-service-management/",
  COMMON_UTILS: url + "mfs-user-group-management/common/",
  LOGIN_MFS: url + "mfs-user-management/adminController/",
  MFS_SERVICE_MANAGEMENT_API_ENDPOINT: url + "mfs-service-management/",
  SOCKET_URL: url + "/paypro",
  MFS_SERVICE_GROUP_MANAGEMENT_ENDPOINT:
    url + "mfs-service-group-management/serviceGroup/",
  COMMON_UTILS_HIERARCHY: url + "/paypro/commonutils/",
  MFS_HIERARCHY_DOWNLOAD: url + "mfs-common-utilities/commonutils/",
  MFS_REPORTS_ENDPOINT: url + "/mfs-reporting-service/",
  OPERATIONS_ENDPOINT: url + "mfs-wallet-management/Master/",
  BILLER_ENDPOINT: url + "mfs-biller-gateway/biller/",
  DASHBOARD_ENDPOINT: url + "/mfs-reporting-service/",
  MFS_TRANSACTION_MANAGEMENT_API_ENDPOINT:
    url + "/mfs-transaction-management/balanceManagement/",
  IMAGE_STORAGE_ENDPOINT: url + "/UploadedData/",
  SMS_ENDPOINT: url + "/mfs-sms-management/",
  CRM_ENDPOINT: url,
  POINTPRO_ENDPOINT: url + "mfs-wallet-management/poinPro/",
  CAMPAIGN_ENDPOINT: url + "mfs-campaign-management/",
  PRODIGI_CREDIT_ENDPOINT: "http://api.ares.ldttechnology.com/",
  DFS_USER_MANAGEMENT_ENDPOINT: url + "dfs-user-management/v1/",
  DFS_WALLET_MANAGEMENT_ENDPOINT: url + "dfs-wallet-management/v1/",
  DFS_LOGIN_MANAGEMENT_ENDPOINT: "dfs-login-management:8086/v1/",
  DFS_AUTHORIZATION_SERVER_ENDPOINT: url + "dfs-authorization-server/",
  SHOW_MODULE: {
    dashboard: false,
    walletManagement: true,
    serviceManagement: true,
    serviceGroupManagement: true,
    ruleManagement: true,
    userGroupManagement: true,
    hierarchyManagement: true,
    limitsAndCapping: true,
    promocodeManagement: true,
    loginManagement: true,
    operations: true,
    billerManagement: true,
    brmsTestPad: true,
    cashinManagement: true,
    notificationManagement: true,
    reports: true,
    kycRequests: true,
    agentRequest: true,
    transaction: true,
    mpc: false,
    fundTransfer: true,
    loyaltyManagement: true,
  },
  // OPEN_MODULE: ["main/dashboard"],
  OPEN_MODULE: ["main/wallet-management"],
};



// WEBPACK FOOTER //
// /Users/ldt/Desktop/ARES-admin-frontend/src/environments/environment.ts